export default {
    profile: null,
    users: {},
    families: {},
    groups: {},
    religiousLeaders: {},
    transactions: {}
}
